import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "M125.4 195.2 26 116.4v266.2l167-133.7zm177.4 66.4-40.7 31.5c-.2.2-.5.3-.7.5-3.3 2.1-7.6 2.1-10.9 0-.2-.2-.5-.3-.7-.5l-40.7-31.5L28.5 406.3h455.1z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  d: "m215.2 241 40.8 31.5 40.8-31.5 93.1-73.9 77.4-61.4H44.7l77.4 61.4zm171.4-45.8L319 248.9l167 133.7V116.4z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M506 95.6c0-.4 0-.8-.1-1.3v-.2c-.1-.4-.1-.8-.3-1.2 0-.1 0-.1-.1-.2 0-.1-.1-.3-.1-.4-.1-.3-.2-.5-.3-.8v-.1c-.2-.4-.4-.7-.6-1.1 0 0 0-.1-.1-.1-.2-.4-.5-.7-.7-1l-.1-.1c-.3-.3-.5-.6-.8-.9-.1 0-.1-.1-.2-.1-.3-.3-.6-.5-1-.7-.1 0-.1-.1-.2-.1-.4-.2-.7-.4-1.1-.6h-.1c-.4-.2-.8-.4-1.2-.5s-.8-.2-1.3-.3h-.1c-.4-.1-.8-.1-1.2-.1H15.6c-.4 0-.8.1-1.2.1h-.1c-.4.1-.8.2-1.3.3-.4.1-.8.3-1.2.5h-.1c-.4.2-.7.4-1.1.6-.1 0-.1.1-.2.1-.3.2-.6.5-1 .7-.1 0-.1.1-.2.1-.3.3-.6.6-.8.9l-.1.1c-.3.3-.5.7-.7 1 0 0 0 .1-.1.1-.2.3-.4.7-.6 1.1v.1c-.1.3-.2.5-.3.8 0 .1-.1.3-.1.4s0 .1-.1.2l-.3 1.2v.2c-.1.5-.1.9-.1 1.3v320.7c0 5.5 4.5 10 10 10h480c5.5 0 10-4.5 10-10zq0 .15 0 0M26 116.4l99.4 78.8 67.6 53.6L26 382.6zm183.2 145.2 40.7 31.5c.2.2.5.3.7.5 3.3 2.1 7.6 2.1 10.9 0 .2-.2.5-.3.7-.5l40.7-31.5 180.7 144.7H28.5zM319 248.9l67.6-53.6 99.4-78.8v266.2zm148.3-143.2-77.4 61.4-93.1 73.9-40.8 31.5-40.8-31.5-93.1-73.8-77.4-61.4h422.6z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }